import "@hotwired/turbo-rails"
import "./controllers"

import { Turbo } from "@hotwired/turbo-rails"

Turbo.StreamActions.close_drawer = function () {
  const el = document.getElementById(this.getAttribute("target"))
  if (el) el.dispatchEvent(new CustomEvent("drawer:close", { bubbles: false }))
}
